const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Account = () => import("@/views/account");
const AccountDetail = () => import("@/views/account/detail");


export default [
    {
        path: "/account",
        name: "account",
        component: Main,
        meta: {
            name: "大屏帐号管理",
            unfold: false, //是否可以被展开
            iconType: "usergroup-add"
        },
        redirect: {
            name: "accountList"
        },
        children: [
            {
                path: "",
                name: "accountList",
                component: Account,
                meta: {
                    name: "大屏帐号管理",
                    role:{}
                },
                children: [
                    {
                        path: "/add",
                        name: "accountAdd",
                        component: AccountDetail,
                        meta: {
                            name: "新增账号",
                            role:{}
                        }
                    },
                    {
                        path: "/edit",
                        name: "accountEdit",
                        component: AccountDetail,
                        meta: {
                            name: "编辑账号",
                            role:{}
                        }
                    }
                ]
            }
        ]
    }
];